import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Depoimento } from 'src/app/models/depoimento.model';
import { ApiService } from '../api.service';
import { daApi, listaDaApi, MAP_DEPOIMENTO, ORDEM_DEPOIMENTO, paraApi, parametrosLista } from '../api-map';

@Injectable({
  providedIn: 'root'
})
export class DepoimentoService {

  constructor(
    public api: ApiService
  ) { }

  get(numeroPagina: number, registroPorPagina: number, ordenacao: string, sentidoOrdenacao: string, filtro?: string): Observable<DepoimentosApi> {
    const query = parametrosLista(numeroPagina, registroPorPagina, ordenacao, sentidoOrdenacao, filtro, ORDEM_DEPOIMENTO, 'date');

    return this.api.get('/testimonial' + query).pipe(
      map((res: any) => {
        const lista = listaDaApi(res, MAP_DEPOIMENTO);
        return { depoimentos: lista.itens, numeroPaginas: lista.numeroPaginas } as DepoimentosApi;
      })
    );
  }

  getById(id): Observable<any> {
    return this.api.get(`/testimonial/${id}`).pipe(map((res: any) => daApi(res, MAP_DEPOIMENTO)));
  }

  post(depoimento: Depoimento): Observable<any> {
    return this.api.post('/testimonial', paraApi(depoimento, MAP_DEPOIMENTO)).pipe(map((res: any) => daApi(res, MAP_DEPOIMENTO)));
  }

  patch(depoimento: Depoimento): Observable<any> {
    return this.api.patch('/testimonial', paraApi(depoimento, MAP_DEPOIMENTO)).pipe(map((res: any) => daApi(res, MAP_DEPOIMENTO)));
  }

  delete(depoimento: Depoimento): Observable<any> {
    return this.api.delete(`/testimonial/${depoimento.id}`);
  }

  deleteSelected(depoimentos: Depoimento[]): Observable<any> {
    return this.api.deleteComCorpo('/testimonial', depoimentos.map(d => ({ id: d.id })));
  }

  postFile(file: File, url: string, fileName: string) {
    return this.api.postFile(file, url, fileName);
  }
}

export interface DepoimentosApi {
  depoimentos: Depoimento[];
  numeroPaginas: number;
}
